import { serverAxiosPromise } from '@alltrails/shared/utils/requests/requestBase';

export default async function apiRequest<T = any>(opts: unknown) {
  try {
    return (await serverAxiosPromise<T>(opts)).data;
  } catch (error) {
    // A response came back with a meaningful data object from the server.
    if (error.response?.data) {
      throw error.response.data;
    }

    // A response came back without a well-formed data object.
    if (error.response) {
      throw Error(`Invoking '${error.response.config?.url}' failed with '${error.response.statusText}' and '${error.response.status}'`);
    }

    // Something failed with the request itself.
    throw error;
  }
}
